import moment from 'moment';

export const formatDate = (date) => {
    if (!date) return 'N/A';
    // 'DD-MMM-YYYY hh:mm A' outputs like: 09-Jul-2026 05:07 PM
    return moment(date).format('DD-MMM-YYYY hh:mm A');
};

export const formatDateTime = (date) => {
    if (!date) return 'N/A';
    return moment(date).format('DD-MMM-YYYY hh:mm A');
};

export const formatDateOnly = (date) => {
    if (!date) return 'N/A';
    return moment(date).format('DD-MMM-YYYY');
};

export const getLocalDateString = (date) => {
    if (!date) return '';
    return moment(date).format('YYYY-MM-DD');
};
